var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 119,
    viewBox: "0 0 125 119",
    fill: "#E4E4E4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.2347 2.97276C60.1848 -0.215105 64.8152 -0.215113 66.7653 2.97276L84.4977 31.9612C85.1911 33.0948 86.3073 33.9057 87.5996 34.2149L120.649 42.1215C124.283 42.991 125.714 47.3948 123.285 50.2345L101.195 76.057C100.331 77.0668 99.9048 78.3789 100.01 79.7035L102.703 113.579C102.999 117.304 99.2533 120.026 95.8019 118.593L64.4171 105.563C63.1898 105.054 61.8102 105.054 60.5829 105.563L29.1981 118.593C25.7467 120.026 22.0006 117.304 22.2967 113.579L24.9899 79.7035C25.0952 78.3789 24.6689 77.0668 23.8051 76.057L1.71502 50.2345C-0.714228 47.3948 0.716663 42.991 4.3511 42.1215L37.4004 34.2149C38.6927 33.9057 39.8089 33.0948 40.5023 31.9612L58.2347 2.97276Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBig);
export default __webpack_public_path__ + "static/media/star-big.8c12157c.svg";
export { ForwardRef as ReactComponent };